<template>
    <div class="slds-form-element">
        <!-- slide toggle -->
        <label
            v-if="!noSlide"
            :class="checkboxClass"
        >
            <input
                ref="checkbox"
                :checked="value || false"
                :disabled="isDisabled"
                type="checkbox"
                @click="toggle"
            >
            <span class="slds-checkbox_faux_container">
                <span class="slds-checkbox_faux"></span>
                <span
                    v-if="showStateLabels"
                    class="slds-checkbox_on"
                >{{ decodeHtml(stateLabelOn) }}</span>
                <span
                    v-if="showStateLabels"
                    class="slds-checkbox_off"
                >{{ decodeHtml(stateLabelOff) }}</span>
            </span>
            <span class="slds-form-element__label slds-m-bottom_none slds-p-left_x-small slds-p-top_xx-small">
                <span>{{ decodeHtml(title) }}</span>
            </span>
            <slot name="tooltip"></slot>
        </label>

        <!-- standard form element -->
        <template v-else-if="isFormElement">
            <label
                class="slds-form-element__label"
                :class="{'slds-p-right_none': tooltipHelpText }"
                :for="checkboxId"
            >{{ decodeHtml(title) }}</label>
            <MATooltip
                v-if="tooltipHelpText"
                showIcon
                inForm
            >
                <span slot="content">
                    {{ tooltipHelpText }}
                </span>
            </MATooltip>
            <div class="slds-form-element__control">
                <span class="slds-checkbox slds-checkbox_standalone">
                    <input
                        :id="checkboxId"
                        ref="checkbox"
                        :checked="value || false"
                        :disabled="isDisabled"
                        type="checkbox"
                        @click="toggle"
                    >
                    <span class="slds-checkbox_faux"></span>
                </span>
            </div>
        </template>

        <!-- standard non-form element -->
        <div
            v-else
            class="slds-form-element__control"
        >
            <div class="slds-checkbox">
                <input
                    :id="checkboxId"
                    ref="checkbox"
                    :checked="value || false"
                    :disabled="isDisabled"
                    type="checkbox"
                    @click="toggle"
                >
                <label
                    :for="checkboxId"
                    class="slds-checkbox__label"
                >
                    <span class="slds-checkbox_faux"></span>
                    <span
                        :class="{'slds-p-right_none': tooltipHelpText }"
                        class="slds-form-element__label"
                    >
                        {{ decodeHtml(title) }}
                    </span>
                </label>
                <MATooltip
                    v-if="tooltipHelpText"
                    showIcon
                    inForm
                >
                    <span slot="content">
                        {{ tooltipHelpText }}
                    </span>
                </MATooltip>
            </div>
        </div>
    </div>
</template>

<script>
    import decodeHtml from '../mixins/decode-html';
    import { getGUID } from '../../js/utils';
    import MATooltip from './MATooltip.vue';

    export default {
        name: 'MACheckbox',
        components: {
            MATooltip
        },
        mixins: [decodeHtml],
        props: {
            value: {
                type: Boolean,
                required: true
            },
            title: {
                type: String,
                required: false,
                default: ''
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            showStateLabels: {
                type: Boolean,
                default: false
            },
            stateLabelOn: {
                type: String,
                default: 'Enabled'
            },
            stateLabelOff: {
                type: String,
                default: 'Disabled'
            },
            toggleBuffer: {
                type: Number,
                default: 0
            },
            noSlide: {
                type: Boolean,
                default: false
            },
            isFormElement: {
                type: Boolean,
                default: false
            },
            tooltipHelpText: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                lastToggleHandlerTimestamp: Date.now(),
                checkboxId: getGUID()
            };
        },
        computed: {
            checkboxClass() {
                return this.noSlide ? 'slds-form-element__control' : 'slds-checkbox_toggle slds-grid';
            }
        },
        watch: {
            value() {
                this.$refs.checkbox.checked = this.value;
            }
        },
        mounted() {
            this.$refs.checkbox.checked = this.value;
        },
        methods: {
            toggle(e) {
                // Click was from mounted()
                if (!e.clientX && !e.clientY) return;

                // Toggle buffering check
                if (e.currentTarget.checked && this.toggleBuffer) {
                    this.$refs.checkbox.disabled = true;
                    setTimeout(() => {
                        this.$refs.checkbox.disabled = false;
                    }, this.toggleBuffer);
                }

                this.$emit('input', !this.value);
            }
        }
    };
</script>

<style scoped>
    .slds-form-element__icon {
        top: 6px !important;
        left: -6px !important;
    }

    .slds-checkbox_toggle [type="checkbox"][disabled] + .slds-checkbox_faux_container .slds-checkbox_faux {
        border: 1px solid #b0adab;
    }
</style>
